﻿import document from 'document';

export const renewalModal = () =>
{
    const selectors = {
        modalNoButton: 'renewal__no_button',
        modalYesButton: 'renewal__yes_button',
        renewalChoice: 'renewal-choice',
        modalContainer: 'renewal-modal-container',
        modalHidden: 'renewal-modal__modal-hidden'
    };

    const yes = "yes";
    const no = "no";

    const toggleModal = (choice) => {

        let fieldValue = "";

        if (choice == yes) {
            fieldValue = "true";
        } else {     
            fieldValue = "false";
        }

        let field = document.getElementById(selectors.renewalChoice);
        field.value = fieldValue;

        let modal = document.getElementById(selectors.modalContainer);
        modal.classList.toggle(selectors.modalHidden);
    }

    const init = () => {
        const noButton = document.getElementById(selectors.modalNoButton);
        const yesButton = document.getElementById(selectors.modalYesButton);

        if (noButton && yesButton) {
            noButton.addEventListener('click', () => { toggleModal(no); });
            yesButton.addEventListener('click', () => { toggleModal(yes); });
        }
    };

    return {
        init
    };
};